import { useEffect, useRef } from 'react';

const useIsClickOutside = () => {
  const clickRef = useRef(null);
  const callbackFunc = useRef(null);
  const setRef = (ref) => {
    clickRef.current = ref;
  };

  const setCallbackFunc = (callback) => {
    callbackFunc.current = callback;
  };

  useEffect(() => {
    function handleClickOutside(event) {
      console.log('event', event.target);
      if (event.target === clickRef.current.current) {
        callbackFunc.current();
      }
    }

    document.addEventListener('click', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('click', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    setRef,
    setCallbackFunc,
  };
};

export default useIsClickOutside;
